/**
 * The fallback value used in case the element is invalid or not renderable.
 * @type {null}
 */
export const FALLBACK_VALUE = null;
